import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { api, FOODSBY_BASE_URL, subscriptionsCache } from '../api/api'
import { addSubscriptionDetails } from '../redux/modules/subscriptions'

/**
 * Hook to return the current user's subscription details
 * Dispatches the latest subscription details of the user to redux and returns the result.
 */
export const useSubscriptionDetails = () => {
  const dispatch = useDispatch()
  const [subscriptionDetailsError, setSubscriptionDetailsError] = useState()
  const [subscriptionEligible, setSubscriptionEligible] = useState()

  const userId = useSelector(state => state?.user?.currentUser?.userId)
  const locationId = useSelector(state => state?.user?.currentUser?.deliveryLocationId)
  const subscriptionDetails = useSelector(state => state?.subscriptions?.subscriptionDetails)

  useEffect(() => {
    let isMounted = true
    if (userId !== undefined && subscriptionDetails === undefined) {
      api
        .get(`${FOODSBY_BASE_URL}/api/v1/credit-cards/subscriptions`)
        .then(result => {
          if (isMounted && result) {
            dispatch(addSubscriptionDetails(result[0] || null)) // Null if no previous subscription
          }
        })
        .catch(err => {
          if (isMounted) {
            setSubscriptionDetailsError(err)
          }
        })
    }

    if (locationId && subscriptionEligible === undefined) {
      api
        .get(
          `${FOODSBY_BASE_URL}/api-monolith/user/subscriptions/eligible?locationId=${locationId}`,
          null,
          { cache: subscriptionsCache },
        )
        .then(result => {
          if (isMounted) {
            setSubscriptionEligible(result?.eligible)
          }
        })
        .catch(err => {
          if (isMounted) {
            setSubscriptionDetailsError(err)
          }
        })
    }

    return () => {
      isMounted = false
    }
  }, [locationId, userId]) //eslint-disable-line

  useEffect(() => {
    if (!subscriptionEligible && subscriptionDetails?.enabled) {
      setSubscriptionEligible(true)
    }
  }, [subscriptionDetails, subscriptionEligible])

  return {
    subscriptionDetails,
    subscriptionDetailsError,
    subscriptionEligible,
  }
}
